import type { RouteRecordRaw } from "vue-router";
import { APP_SETTINGS_PATIENTREFERRAL_ROUTES as PATIENT_REFERAL } from "@/Generated/Routes/paths";

const patientReferral: RouteRecordRaw[] = [
  {
    ...PATIENT_REFERAL.root,
    meta: {
      i18nTitle: "settings.patient_referral-title",
    },
    component: () => import("@/Views/settings/patient-referral/PatientReferral.vue"),
  },
];

export default patientReferral;
